import React from "react";
import { CCol, CFormGroup, CInput, CLabel, CRow } from "@coreui/react";
import { useAutoInvoiceFormContext } from "../context/AutoInvoiceFormContext";
import { FieldErrors } from "../../form/FieldErrors";
import { getFieldErrors } from "../../../models/errors";
import DepartmentSelect from "../../location/DepartmentSelect";
import DistrictSelect from "../../location/DistrictSelect";
import CitySelect from "../../location/CitySelect";

const SectionDivider: React.FC<{ icon: string; label: string }> = ({ icon, label }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
    <div style={{ width: "4px", height: "18px", background: "#006657", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
    <i className={`fa ${icon} mr-2`} style={{ fontSize: "0.85rem", color: "var(--theme-accent)" }}></i>
    <h6 style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
      {label}
    </h6>
    <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
  </div>
);

const FormLabel: React.FC<{ required?: boolean; children: React.ReactNode }> = ({ required, children }) => (
  <CLabel className="mb-0" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>
    {required && <span className="text-danger mr-1">*</span>}
    {children}
  </CLabel>
);

const AutoInvoiceFormTransactionLocationSection: React.FC = () => {
  const {
    autoInvoiceRef,
    transactionDepartment,
    transactionDistrict,
    transactionCity,
    errors,
    onTransactionAddressChange,
    onTransactionHouseNumberChange,
    onTransactionDepartmentChange,
    onTransactionDistrictChange,
    onTransactionCityChange,
  } = useAutoInvoiceFormContext();

  return (
    <>
      <SectionDivider icon="fa-map-marker" label="Dirección de Transacción" />
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>Dirección:</FormLabel>
          </CCol>
          <CCol md={6}>
            <CInput
              type="text"
              defaultValue={
                autoInvoiceRef.current
                  ? autoInvoiceRef.current.transactionAddress
                  : ""
              }
              onChange={onTransactionAddressChange}
              placeholder="Dirección"
            />
            <FieldErrors
              errors={getFieldErrors("transactionAddress", errors) as string[]}
            />
          </CCol>
          <CCol md={2}>
            <FormLabel required>Nro. de casa:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="number"
              defaultValue={
                autoInvoiceRef.current
                  ? autoInvoiceRef.current.transactionHouseNumber
                  : undefined
              }
              onChange={onTransactionHouseNumberChange}
              placeholder="Número de casa"
            />
            <FieldErrors
              errors={
                getFieldErrors("transactionHouseNumber", errors) as string[]
              }
            />
          </CCol>
        </CRow>
      </CFormGroup>
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>Departamento:</FormLabel>
          </CCol>
          <CCol md={2}>
            <DepartmentSelect
              onChange={onTransactionDepartmentChange}
              value={transactionDepartment}
              placeholder="Departamento"
            />
            <FieldErrors
              errors={
                getFieldErrors("transactionDepartment", errors) as string[]
              }
            />
          </CCol>
          <CCol md={2}>
            <FormLabel required>Distrito:</FormLabel>
          </CCol>
          <CCol md={2}>
            <DistrictSelect
              onChange={onTransactionDistrictChange}
              value={transactionDistrict}
              placeholder="Distrito"
              departmentValue={
                transactionDepartment !== null
                  ? transactionDepartment
                  : undefined
              }
            />
            <FieldErrors
              errors={getFieldErrors("transactionDistrict", errors) as string[]}
            />
          </CCol>
          <CCol md={2}>
            <FormLabel required>Ciudad:</FormLabel>
          </CCol>
          <CCol>
            <CitySelect
              onChange={onTransactionCityChange}
              placeholder="Ciudad"
              value={transactionCity}
              district={
                transactionDistrict !== null ? transactionDistrict : undefined
              }
              department={
                transactionDepartment !== null
                  ? transactionDepartment
                  : undefined
              }
            />
            <FieldErrors
              errors={getFieldErrors("transactionCity", errors) as string[]}
            />
          </CCol>
        </CRow>
      </CFormGroup>
    </>
  );
};

export default AutoInvoiceFormTransactionLocationSection;
